{
  "name": "hms-home",
  "version": "1.23.6",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:test": "ng build --configuration test",
    "build:prod": "ng build --configuration production",
    "build:quick": "ng build --configuration quick",
    "compile-check": "ngc --noEmit --skipLibCheck",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:run": "ng test --watch=false",
    "test:ci": "ng test --configuration=ci",
    "lint": "ng lint && stylelint \"src/**/*.{css,scss}\" --cache --cache-location node_modules/.cache/stylelint/",
    "lint:errors": "ng lint --quiet && stylelint \"src/**/*.{css,scss}\" --cache --cache-location node_modules/.cache/stylelint/ --quiet",
    "lint:fix": "ng lint --fix && stylelint \"src/**/*.{css,scss}\" --cache --cache-location node_modules/.cache/stylelint/ --fix",
    "prepare": "husky",
    "i18n-consistency": "node tools/i18n-consistency.js",
    "i18n-usage": "node tools/i18n-usage.js",
    "i18n-check": "npm run i18n-consistency && npm run i18n-usage"
  },
  "private": true,
  "engines": {
    "node": ">=22.22.3"
  },
  "dependencies": {
    "@angular/cdk": "^22.2.5",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/material": "^22.2.5",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@ngx-translate/core": "^18.1.0",
    "@puzzel/euwa-wrapper": "^1.0.3",
    "@sentry/angular": "^10.78.0",
    "marked": "^17.0.6",
    "marked-base-url": "^1.1.10",
    "ngx-markdown": "^22.1.1",
    "ngx-matomo-client": "^10.0.0",
    "ngx-pagination": "^6.0.3",
    "prismjs": "^1.30.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.3",
    "@angular/localize": "^22.2.3",
    "@eslint/js": "^10.0.1",
    "@smarttools/eslint-plugin-rxjs": "^1.0.22",
    "@types/node": "^20.19.43",
    "@vitest/browser-playwright": "^4.1.12",
    "@vitest/coverage-v8": "^4.1.12",
    "angular-eslint": "22.6.0",
    "eslint": "^10.13.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.5",
    "eslint-plugin-boundaries": "^6.0.2",
    "eslint-plugin-import-x": "^4.17.1",
    "husky": "^9.1.7",
    "lint-staged": "^17.6.0",
    "marked-katex-extension": "^5.1.13",
    "playwright": "^1.64.1",
    "prettier": "^3.9.10",
    "prettier-plugin-organize-imports": "^4.3.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.4.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.72.1",
    "vitest": "^4.1.12"
  },
  "overrides": {
    "handlebars": "^4.7.10"
  },
  "lint-staged": {
    "src/**/*.{html,js,jsx,ts,tsx}": [
      "eslint --fix"
    ],
    "src/**/*.{css,scss}": [
      "stylelint --fix"
    ],
    "src/**/*.{html,js,jsx,ts,tsx,json,css,scss,md,yml}": [
      "prettier --write"
    ]
  }
}
